export default {
      id: "financial-ratios-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#financial-ratios",
      toString: function () {
        return this.url;
      }
    }